import { User } from '@/types/User';
import { hasTokens } from '@/utils/cookies';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: User | null;
  setUser: (user: User | null) => void;
  checkAuth: () => void;
  setAuthenticated: (state: boolean) => void;
  clearAuthState: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: hasTokens(),
      isLoading: true,
      user: null,

      checkAuth: () => {
        const tokens = hasTokens();
        set({ isAuthenticated: tokens, isLoading: false });
      },

      setAuthenticated: (isAuthenticated: boolean) => {
        set({ isAuthenticated, isLoading: false });
      },

      setUser: (user) => {
        set({ user });
      },

      clearAuthState: () => {
        set({ isAuthenticated: false, isLoading: false, user: null });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        user: state.user,
      }),
    }
  )
);
